import { css } from 'styled-system/css';

export const switchBettypeStyle = {
	root: css({
		display: 'contents',
	}),
	filterWrap: css({
		base: {
			py: '6px',
			mt: '-6px',
			position: 'sticky',
			top: 'calc(var(--header-height) + 36px)',
			md: {
				top: '48px',
			},
			'&[data-fixed="true"]': {
				bgColor: 'whiteOpacity.100',
				p: '6px',
				mx: '-6px',
				zIndex: 1,
				overflow: 'hidden',
				md: {
					bgColor: 'var(--body-bg)',
				},
				_dark: {
					bgColor: 'var(--s800)',
				},
			}
		}
	}),
	filter: css({
		base: {
			display: 'flex',
		}
	}),
	filterItem: css({
		base: {
			flex: '1',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			flexWrap: 'wrap',
			bgColor: 'var(--other-lv2)',
			color: 'black.2',
			textAlign: 'center',
			px: '6px',
			py: '3px',
			cursor: 'pointer',
			borderRight: '1px solid {colors.black.5}',
			lineHeight: '1.2em',
			minH: '24px',
			md: {
				py: '6px',
				minH: '30px',
			},
			_first: {
				rounded: '6px 0 0 6px',
			},
			_last: {
				rounded: '0 6px 6px 0',
				borderRight: 'none',
			},
			_active: {
				bgColor: 'brand.500',
				color: 'whiteOpacity.100',
				position: 'relative',
			}
		}
	}),
	filterItemWithTip: css({
		base: {
			_active: {
				_after: {
					content: '""',
					position: 'absolute',
					width: '10px',
					height: '10px',
					left: 'calc(50% - 5px)',
					bottom: '-7px',
					bgColor: '#FFF5C2',
					transform: 'translateY(100%) rotate(45deg)',
				}
			}
		},
	}),
	tipWrap: css({
		base: {
			maxH: '0',
			overflow: 'hidden',
			transition: 'max-height 200ms ease-in',
			_active: {
				overflow: 'auto',
				maxH: '200px',
			}
		},
	}),
	tip: css({
		base: {
			position: 'relative',
			p: '6px',
			pr: '32px',
			mt: '5px',
			mb: '6px',
			display: 'flex',
			alignItems: 'center',
			bgColor: '#FFF5C2',
			color: 'blackOpacity.100',
			rounded: '6px',
		}
	}),
	tipIcon: css({
		base: {
			color: '#FFCC33',
			minW: '36px',
			'& .icon': {
				width: '36px',
				height: '36px',
			},
		}
	}),
	tipText: css({
		base: {
			fontWeight: '500',
		}
	}),
	tipMessage: css({
		base: {
		},
	}),
	button: css({
		base: {
			rounded: '3px',
			p: '3px',
			fontSize: '12px',
			minH: 'unset',
			bgColor: 'primary.400',
			mt: '3px',
			'& .icon': {
				width: '16px',
				height: '16px',
			},
		},
	}),
	buttonText: css({
		base: {
			textAlign: 'left',
		},
	}),
	closeButton: css({
		base: {
			position: 'absolute',
			top: '0',
			right: '0',
			color: 'blackOpacity.38',
			p: '3px',
			'& .icon': {
				width: '20px',
				height: '20px',
			},
		},
	}),
}